// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2-zPl","fileBtn":"File_fileBtn__30sO3","closeBtn":"File_closeBtn__2eYND","fileSelected":"File_fileSelected__338A0","disabled":"File_disabled__1_obM"};